// extracted by mini-css-extract-plugin
export default {"faqItem":"styles_faqItem__sIYqD","question":"styles_question__qczae","arrow":"styles_arrow__2BQM2","open":"styles_open__HsVoJ","answer":"styles_answer__Y5W54"};